const STICKY_CONFIG = {
    stickyOffset: 180,
    topPosition: '0',
    selectors: {
        content: '[data-hero-aside-content]',
        stopPoint: '[data-location="below-page-content"]'
    }
};

const heroContent = document.querySelector(STICKY_CONFIG.selectors.content);

if (heroContent) {
    heroContent.classList.add('hero-aside-content');
    initStickyAside(heroContent);
}

/**
 * Pins the backpage aside to the viewport on scroll, releasing it at the stop point.
 * @param {HTMLElement} heroContent The `[data-hero-aside-content]` element to pin.
 */
function initStickyAside(heroContent) {
    // Re-measured on resize: the pinned element is out of flow, so its width can't be inherited from the layout
    let initialOffset = heroContent.offsetTop;
    let initialWidth = heroContent.offsetWidth;

    function measure() {
        const wasFixed = heroContent.classList.contains('hero-aside-content--fixed');

        // offsetTop/offsetWidth are only meaningful in flow, so drop out of fixed to read them
        setPositionState(heroContent, false);
        heroContent.style.width = '';
        initialOffset = heroContent.offsetTop;
        initialWidth = heroContent.offsetWidth;

        if (wasFixed) handleScroll();
    }

    function setPositionState(element, isFixed, stopPosition = null) {
        element.classList.toggle('hero-aside-content--fixed', isFixed);
        element.classList.toggle('hero-aside-content--relative', !isFixed);

        if (!isFixed) {
            element.style.top = 'auto';
            element.style.width = `${initialWidth}px`;
            return;
        }

        element.style.top = stopPosition ?? STICKY_CONFIG.topPosition;
        element.style.width = `${initialWidth}px`;
    }

    function handleBasicSticky(scrollPosition) {
        const shouldBeFixed = scrollPosition > (initialOffset + STICKY_CONFIG.stickyOffset);
        setPositionState(heroContent, shouldBeFixed);
    }

    function handleEnhancedSticky(scrollPosition, stopPoint) {
        const stopPointTop = stopPoint.getBoundingClientRect().top + scrollPosition;
        const heroHeight = heroContent.offsetHeight;
        const stopPosition = stopPointTop - heroHeight;

        if (scrollPosition <= (initialOffset + STICKY_CONFIG.stickyOffset)) {
            return setPositionState(heroContent, false);
        }

        // Past the stop point the aside rides up with the content instead of staying pinned
        if (scrollPosition >= stopPosition) {
            return setPositionState(heroContent, true, `${stopPosition - scrollPosition}px`);
        }

        setPositionState(heroContent, true);
    }

    function handleScroll() {
        const scrollPosition = window.scrollY;
        const stopPoint = document.querySelector(STICKY_CONFIG.selectors.stopPoint);

        if (!stopPoint) {
            handleBasicSticky(scrollPosition);
            return;
        }

        handleEnhancedSticky(scrollPosition, stopPoint);
    }

    // Trailing debounce - resize measurement is expensive and only the settled size matters
    function debounce(callback, wait) {
        let timeout;
        return function debounced(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => callback(...args), wait);
        };
    }

    // rAF throttle, so the pin updates during the scroll rather than after it stops
    function requestFrame(callback) {
        let ticking = false;
        return function throttled(...args) {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(() => {
                callback(...args);
                ticking = false;
            });
        };
    }

    window.addEventListener('scroll', requestFrame(handleScroll), { passive: true });
    window.addEventListener('resize', debounce(measure, 150), { passive: true });

    handleScroll();
}
